<!--Banner part code-->
<div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel  uk-flex-center uk-flex-middle"
            style="background-image: url(../../assets/djangobanner.png);">
            <div class="uk-section uk-light">
                <div class="uk-container-small uk-width-2xlarge" style="padding-top:30px ;">

                    <h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;"> Django Application Development </h1>


                   

                    <p class="uk-text-left uk-padding-large uk-padding-remove-vertical" style="font-size: 20px;">We create dynamic and effective web outcomes using Django. Our Django Development Services hold you in full control.

                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Banner part code ends-->
<div class="uk-container">
        <h1 class="uk-text-center"  style="font-weight:600"><span>Advance & Agile Django Services</span></h1>
    <br>
        <p class="uk-text-medium uk-text-justify" style="font-size: 18px;"> Django is a high-quality Python 
            framework that enables quick app development and sensible layouts. Companies and specialists 
            equally trust Django framework to build self-sufficient web applications. It helps to develop
             websites with clarity and accuracy.
        </p>
        <p class="uk-text-medium uk-text-justify" style="font-size: 18px;"> WebSoulLabs is a top-level Django
             development firm which specializes in creating high performing, popular and hassle-free web
              applications using Django. Our specialists deliver a span of Django development services with 
              enormous industry knowledge.
        </p>
        
</div>
    <br><br>
    <!--Paragraph part code ends-->

<div class="uk-container">
    <h1 class="uk-text-center"  style="font-weight:600">Django development services </h1>
              <br>
    <div class="uk-child-width-1-3@s uk-grid-match" uk-grid>
        <div class="uk-animation-toggle" tabindex="0">
            <div class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/cus.jpg" width="70" height="70" alt="">
                <h3>Django Website Development</h3>
               
            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/travels.png" width="55" height="55" alt="">
                <h3>Django Web Application Development</h3>
               
            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/keys.png" width="40" height="40" alt="">
                <h3>Django Template Design</h3>
               
            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/pink.png" width="50" height="50" alt="">
                <h3>Mobile Application Development Using Django</h3>
               
            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/fast.jpg" width="65" height="65" alt="">
                <h3>Django Web Interface Design</h3>
               
            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/eweb.png" width="55" height="55" alt="">
                <h3>Django Ecommerce  Application Development</h3>
               
            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/ind.png" width="70" height="70" alt="">
                <h3>Ui Design using Django</h3>
               
            </div>
        </div>
        <div class="uk-animation-toggle" tabindex="0">
            <div class="uk-card uk-card-default uk-text-center uk-card-body uk-animation-scale-up uk-transform-origin-bottom-center">
                <img class="uk-border-pill uk-align-center" src="assets/image.png" width="55" height="55" alt="">
                <h3>Existing Application Maintenance</h3>
               
            </div>
        </div>

    </div>
</div>
<br>
<br>
<br>

<div class="uk-section  uk-padding" style="background-color: #135796; padding-bottom: 0px;">
    <div class="uk-container uk-container-large ">
        <h1 class="uk-text-center" style="color: snow; font-weight:600;">We Build Powerful Web Applications With Django </h1>
        <p class="uk-text-center uk-text-small" style="color: snow;font-size: 20px;">Django is regularly recognized as a peach among the creative Python highlights.</p>
        <br>   
    <div class="uk-grid-match uk-child-width-1-3@s  uk-padding uk-text-center"style="padding-top: 20px; padding-bottom: 20px;" uk-grid>
        <div>
            <div class="uk-card uk-card-muted  uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                <div class="pa">
                    <span class="text-white">
                        <img src="/assets/businessman.svg" width="30" height="30" alt="svg" style="padding-top: 20px;"></span>
                    <h3 class="uk-text-center" style="color: snow; margin-top: 0px;"><strong>Conceptualizing</strong></h3>
                    <p class="uk-text-justify" style="color: snow;word-spacing:1px;letter-spacing: -1px;">Our experts in the Django development team draw up a
                         master plan that delivers a solution that is dynamic, functional and tailored to your business objectives.
                    </p>
                </div>
            </div>
        </div>
        <div>
            <div class="uk-card uk-card-muted  uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                <div class="pa1">
                    <span class="text-white">
                        <img src="../../assets/payment.svg" width="30" height="30" alt="svg" style="padding-top: 20px"></span>
                    <h3 class="uk-text-center" style="color: snow;  margin-top: 0px;"><strong>Concoct Estimation</strong></h3>
                    <p class="uk-text-justify" style="color: snow;word-spacing:1px;letter-spacing: -1px;">Designing and building a website requires prudent planning
                         when it comes to estimated costs and delivery.</p>
                </div>
            </div>
        </div>
        <div>
            <div class="uk-card uk-card-muted uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                <div class="pa2">
                    <span class="text-white">
                        <img src="../../assets/branding.svg" width="30" height="30" alt="svg" style="padding-top: 20px"></span>
                    <h3 class="uk-text-center"style="color: snow;  margin-top: 0px;"><strong>Template Fabrication</strong></h3>
                    <p class="uk-text-justify" style="color: snow;word-spacing:1px;letter-spacing: -1px;">We fabricate interactive prototypes of the web application to be developed and recognize the shortcomings if any. </p>
                </div>
            </div>
        </div>
        <div>
            <div class="uk-card uk-card-muted uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                <div class="pa2">
                    <span class="text-white">
                        <img src="../../assets/devps.svg" width="30" height="30" alt="svg" style="padding-top: 20px"></span>
                    <h3 class="uk-text-center " style="color: snow;  margin-top: 0px;"><strong>Application Development</strong></h3>
                    <p class="uk-text-justify" style="color: snow;word-spacing:1px;letter-spacing: -1px;">Our developers strive hard to build a robust, secure and scalable web
                         application by formulating an agile methodology and tailored.</p>
                </div>
            </div>
        </div>
        <div>
            <div class="uk-card uk-card-muted uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                <div class="pa2">
                    <span class="text-white">
                        <img src="../../assets/upload.svg" width="30" height="30" alt="svg" style="padding-top: 20px"></span>
                    <h3 class="uk-text-center" style="color: snow;  margin-top: 0px; padding-top: 20px;"><strong>Deployment</strong></h3>
                    <p class="uk-text-justify" style="color: snow; padding-top:10px;word-spacing:1px;letter-spacing: -1px;" >Successful deployment of applications and we will be available just a call away for any kind of post-deployment support.</p>
                </div>
            </div>
        </div>
    </div>
    </div>
</div>
<div class="uk-section uk-padding" style=" padding-bottom: 0px;">
    <div class="uk-container">
      
          <h1 class="uk-text-center" style="font-weight:600;">Building Powerful Web Apps With Django</h1>
          <br>
          <div class="uk-column-1-2@s">
  
              
              <p class="uk-text-medium uk-text-justify" style="font-size: 18px; padding-top: 40px;">Django is an open-source
                 python web framework used for rapid web development. When building a site that requires 
                 a strong and secure foundation that protects transactions and sensitive data. Django is
                  a great framework to use, it hides your source code by default and it's often one of the 
                  first frameworks to respond to a new vulnerability. Websites built from it are secured, scalable,
                   and maintainable at the same time. Django has Powerful customization features for all types of 
                   content including multimedia, image etc. It has been rapidly gaining popularity for its pragmatic
                    design and ease of use.</p>
              <img data-src="assets/djp.jpg" width="700" height="700" alt="" uk-img>
  <br><br>
          </div>
    </div>
</div>
<h1 class="uk-text-center"><span>Related Services</span></h1>
<br>
<div class="uk-container">
    <div class="uk-grid-small uk-child-width-1-2@s uk-child-width-1-4@m  uk-flex-center uk-grid-match" uk-grid>
       
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                
                <img class=" uk-align-center" src="assets/icons/mean1.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">MEAN Stack<br> Development</h4>
        
            </div>
        </div>
        

        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/odoo1.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Odoo App<br> Development</h4>


            </div>
        </div>

        

       


       

    </div>

</div>

<!--Related Services part code ends-->



<!--Technology stack part code-->
<br>
<h1 class="uk-text-center"><span>Technology Stack</span></h1>
<br>
<div class="uk-container">
    <div class=" wss uk-child-width-1-4@s uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/mongo.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">MongoDB</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/node.jpg" width="80" height="80"
                    alt="border-circle">
                <h4 style="font-weight:600">NodeJS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/express.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">ExpressJS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/angular.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">AngularJS</h4>
            </div>
        </div>
    </div>
    <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/ths.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Python</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/ng.jpg" width="80" height="80"
                    alt="border-circle">
                <h4 style="font-weight:600">Nginx</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/boos.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Bootstrap</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/post.jpg" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">PostgreSQL</h4>
            </div>
        </div>
    </div>
</div>
    
<br>
<!--Technology stack part code ends-->